import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { ButtonReg } from 'atoms/Buttons'
import { FormSelect, FormNumber, FormNumberStep } from 'atoms/Inputs'
import IconPng from 'atoms/IconPng'
import { CardContainer } from './styles'
import lo from 'lodash'
import { getLookup } from 'Redux/actions/LookupActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import { BLASTING_REPORT, BLASTING_REPORT_EXPLOSIVE } from 'fixtures/api';
import { NewBlastingReport } from 'fixtures/TemplateData'

const ic_cancel = require('App/assets/images/ic_cancel.png')

export class ExplosiveUsage extends PureComponent {

  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup() {
    const { getLookup, toggleIsLoading } = this.props
    toggleIsLoading(true)
    getLookup(BLASTING_REPORT, BLASTING_REPORT_EXPLOSIVE)
    toggleIsLoading(false)
  }

  onChangeVal(value, id, field) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === id));
    details.detailPit[pitIndex]['explosiveUsage'][field] = value
    fnChange(details, 'details')
  }

  onChangeType(value, pitId, itemId, field, key) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === pitId));
    const itemIndex = details.detailPit[pitIndex].explosiveUsage[key].findIndex((item => item.id === itemId));
    details.detailPit[pitIndex].explosiveUsage[key][itemIndex][field] = value
    fnChange(details, 'details')
  }

  addType(id, key) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === id));
    const newType = {
      ...lo.cloneDeep(NewBlastingReport.details.detailPit[0].explosiveUsage[key][0]),
      id: uuidv4()
    }
    details.detailPit[pitIndex].explosiveUsage[key].push(newType)
    fnChange(details, 'details')
  }

  removeType(pitId, itemId, key) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === pitId));
    // at least 1 item, only remove if length > 1
    if (details.detailPit[pitIndex].explosiveUsage[key].length > 1) {
      const updatedType = details.detailPit[pitIndex].explosiveUsage[key].filter(item => item.id !== itemId);
      details.detailPit[pitIndex].explosiveUsage[key] = updatedType
      fnChange(details, 'details')
    }
  }

  render() {
    const { theme, pit, isDisabled, lookups, formRefs } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <div className={'row col-12 mx-0 px-0'}>
        <CardContainer mb={'16px'}>
          <div className={'row col-12 mx-0 px-0'}>
            <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={'#473A94'}>
              Explosive Usage
            </Label>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Explosive Type
              </Label>
              <FormSelect
                placeholder={'Select Explosive Type'}
                onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'explosiveType')}
                options={lookups.blastingReportExplosiveType || []}
                value={pit.explosiveUsage.explosiveType}
                disabled={isDisabled}
                valField={'name'}
                dispField={'name'}
                arrowSize={'16px'}
                ref={(ref) => (formRefs[`explosiveType_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Down To Hole <span style={{color: theme.mocaOrange}}>(KG)</span>
              </Label>
              <FormNumber
                placeholder={'0'}
                alignRight
                mb={'8px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'downToHole')}
                value={pit.explosiveUsage.downToHole}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`downToHole_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-12 px-0'}>
              <Label lineheight={'14px'} size={'12px'}>
                Amonium Nitrate <span style={{color: theme.mocaOrange}}>(KG)</span>
              </Label>
              <FormNumberStep
                placeholder={'0'}
                mb={'8px'}
                step={lookups.blastingReportAmoniumNitrate}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'amoniumNitrate')}
                value={pit.explosiveUsage.amoniumNitrate}
                disabled={isDisabled}
                {...inputConfig}
              />
            </div>
          </div>

          {/* dynamite template */}
          {pit.explosiveUsage.dynamites &&
          <>
            <div className={'row col-12 mx-0 px-0 mt-0'}>
              <div className={'col-6 px-0'}>
                <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={theme.mocaOrange}>
                  Dynamite
                </Label>
              </div>
              <div className={'col-6 px-0 d-flex justify-content-end'}>
                <ButtonReg 
                  onClick={() => !isDisabled ? this.addType(pit.id, 'dynamites') : {}} 
                  btnIcon={'plus-circle'}
                  btnIconColor={theme.mocaGreen}
                  btnTxt={'Add Type'}
                  color={theme.mocaGreen}
                  bg={'white'}
                  size={'12px'}
                  height={'21px'}
                />
              </div>
            </div>
            {pit.explosiveUsage.dynamites.map((dynamite, idx) => (
              <div key={idx} className={'row col-12 mx-0 px-0 mb-2'}>
                <div className={'col-1 px-0 d-flex align-items-center justify-content-center'}>
                  <IconPng 
                    srcIcon={ic_cancel} 
                    mx={"8px"} 
                    size={"auto"} 
                    h={"17"} 
                    showPointer 
                    onClick={() => !isDisabled ? this.removeType(pit.id, dynamite.id, 'dynamites') : {}}
                  />
                </div>
                <div className={'col-11 px-0'}>
                  <div className={'row col-12 mx-0 px-0'}>
                    <div className={'col-4 px-2'}>
                      <Label lineheight={'14px'} size={'12px'}>
                        Dynamite Type
                      </Label>
                      <FormSelect
                        placeholder={'Select booster type'}
                        onChangeVal={e => this.onChangeType(
                          e.target.value, pit.id, dynamite.id, 'dynamiteType', 'dynamites')}
                        options={lookups.blastingReportDynamiteType || []}
                        value={dynamite.dynamiteType}
                        disabled={isDisabled}
                        valField={'name'}
                        dispField={'name'}
                        arrowSize={'16px'}
                        ref={(ref) => (formRefs[`dynamiteType_${dynamite.id}`] = ref)}
                        {...inputConfig}
                      />
                    </div>
                    <div className={'col-4 px-2'}>
                      <Label lineheight={'14px'} size={'12px'}>
                        Weight
                      </Label>
                      <FormSelect
                        placeholder={'Select weight'}
                        onChangeVal={e => this.onChangeType(
                          e.target.value, pit.id, dynamite.id, 'dynamiteWeight', 'dynamites')}
                        options={
                          lookups.blastingReportDynamiteType.find((d) => d.name === dynamite.dynamiteType)
                          ? lookups.blastingReportDynamiteType.find(
                            (d) => d.name === dynamite.dynamiteType).children.map((d) => ({ name: d.nameDisplay }))
                          : []}
                        value={dynamite.dynamiteWeight}
                        disabled={isDisabled}
                        valField={'name'}
                        dispField={'name'}
                        arrowSize={'16px'}
                        ref={(ref) => (formRefs[`dynamiteWeight_${dynamite.id}`] = ref)}
                        {...inputConfig}
                      />
                    </div>
                    <div className={'col-4 px-0 pl-2'}>
                      <Label lineheight={'14px'} size={'12px'}>
                        Amount <span style={{color: theme.mocaOrange}}>(pcs)</span>
                      </Label>
                      <FormNumber
                        placeholder={'0'}
                        alignRight
                        mb={'8px'}
                        onChangeVal={value => this.onChangeType(
                          value, pit.id, dynamite.id, 'dynamiteAmount', 'dynamites')}
                        value={dynamite.dynamiteAmount}
                        disabled={isDisabled}
                        ref={(ref) => (formRefs[`dynamiteAmount_${dynamite.id}`] = ref)}
                        {...inputConfig}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
          }

          {/* inholes template */}
          {pit.explosiveUsage.inholes &&
          <>
          <div className={'row col-12 mx-0 px-0 mt-0'}>
            <div className={'col-6 px-0'}>
              <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={theme.mocaOrange}>
                Detonator
              </Label>
            </div>
            <div className={'col-6 px-0 d-flex justify-content-end'}>
              <ButtonReg 
                onClick={() => !isDisabled ? this.addType(pit.id, 'inholes') : {}} 
                btnIcon={'plus-circle'}
                btnIconColor={theme.mocaGreen}
                btnTxt={'Add Type'}
                color={theme.mocaGreen}
                bg={'white'}
                size={'12px'}
                height={'21px'}
              />
            </div>
          </div>
          {pit.explosiveUsage.inholes.map((inhole, idx) => (
            <div key={idx} className={'row col-12 mx-0 px-0 mb-2'}>
              <div className={'col-1 px-0 d-flex align-items-center justify-content-center'}>
                <IconPng 
                  srcIcon={ic_cancel} 
                  mx={"8px"} 
                  size={"auto"} 
                  h={"17"} 
                  showPointer 
                  onClick={() => !isDisabled ? this.removeType(pit.id, inhole.id, 'inholes') : {}}
                />
              </div>
              <div className={'col-11 px-0'}>
                <div className={'row col-12 mx-0 px-0'}>
                  <div className={'col-4 px-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Inhole Type
                    </Label>
                    <FormSelect
                      placeholder={'Select inhole type'}
                      onChangeVal={e => this.onChangeType(
                        e.target.value, pit.id, inhole.id, 'inholeType', 'inholes')}
                      options={lookups.blastingReportInholeType || []}
                      value={inhole.inholeType}
                      disabled={isDisabled}
                      valField={'name'}
                      dispField={'name'}
                      arrowSize={'16px'}
                      ref={(ref) => (formRefs[`inholeType_${inhole.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                  <div className={'col-4 px-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Length
                    </Label>
                    <FormSelect
                      placeholder={'Select length'}
                      onChangeVal={e => this.onChangeType(
                        e.target.value, pit.id, inhole.id, 'inholeLength', 'inholes')}
                      options={lookups.blastingReportInholeLength || []}
                      value={inhole.inholeLength}
                      disabled={isDisabled}
                      valField={'name'}
                      dispField={'name'}
                      arrowSize={'16px'}
                      ref={(ref) => (formRefs[`inholeLength_${inhole.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                  <div className={'col-4 px-0 pl-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Amount <span style={{color: theme.mocaOrange}}>(pcs)</span>
                    </Label>
                    <FormNumber
                      placeholder={'0'}
                      alignRight
                      mb={'8px'}
                      onChangeVal={value => this.onChangeType(
                        value, pit.id, inhole.id, 'inholeAmount', 'inholes')}
                      value={inhole.inholeAmount}
                      disabled={isDisabled}
                      ref={(ref) => (formRefs[`inholeAmount_${inhole.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
          </>
          }

          <div className={'row col-12 mx-0 px-0 mt-0'}>
            <div className={'col-6 px-0'}>
              <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={theme.mocaOrange}>
              Surface Type
              </Label>
            </div>
            <div className={'col-6 px-0 d-flex justify-content-end'}>
              <ButtonReg 
                onClick={() => !isDisabled ? this.addType(pit.id, 'surfaces') : {}} 
                btnIcon={'plus-circle'}
                btnIconColor={theme.mocaGreen}
                btnTxt={'Add Type'}
                color={theme.mocaGreen}
                bg={'white'}
                size={'12px'}
                height={'21px'}
              />
            </div>
          </div>
          {pit.explosiveUsage.surfaces.map((surface, idx) => (
            <div key={idx} className={'row col-12 mx-0 px-0 mb-2'}>
              <div className={'col-1 px-0 d-flex align-items-center justify-content-center'}>
                <IconPng 
                  srcIcon={ic_cancel} 
                  mx={"8px"} 
                  size={"auto"} 
                  h={"17"} 
                  showPointer 
                  onClick={() => !isDisabled ? this.removeType(pit.id, surface.id, 'surfaces') : {}}/>
              </div>
              <div className={'col-11 px-0'}>
                <div className={'row col-12 mx-0 px-0'}>
                  <div className={'col-4 px-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Surface Type
                    </Label>
                    <FormSelect
                      placeholder={'Select surface type'}
                      onChangeVal={e => this.onChangeType(e.target.value, pit.id, surface.id, 'surfaceType', 'surfaces')}
                      options={lookups.blastingReportSurfaceType || []}
                      value={surface.surfaceType}
                      disabled={isDisabled}
                      valField={'name'}
                      dispField={'name'}
                      arrowSize={'16px'}
                      ref={(ref) => (formRefs[`surfaceType_${surface.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                  <div className={'col-4 px-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Length
                    </Label>
                    <FormSelect
                      placeholder={'Select length'}
                      onChangeVal={e => this.onChangeType(
                        e.target.value, pit.id, surface.id, 'surfaceLength', 'surfaces')}
                      options={lookups.blastingReportSurfaceLength || []}
                      value={surface.surfaceLength}
                      disabled={isDisabled}
                      valField={'name'}
                      dispField={'name'}
                      arrowSize={'16px'}
                      ref={(ref) => (formRefs[`surfaceLength_${surface.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                  <div className={'col-4 px-0 pl-2'}>
                    <Label lineheight={'14px'} size={'12px'}>
                      Amount <span style={{color: theme.mocaOrange}}>(pcs)</span>
                    </Label>
                    <FormNumber
                      placeholder={'0'}
                      alignRight
                      mb={'8px'}
                      onChangeVal={value => this.onChangeType(
                        value, pit.id, surface.id, 'surfaceAmount', 'surfaces')}
                      value={surface.surfaceAmount}
                      disabled={isDisabled}
                      ref={(ref) => (formRefs[`surfaceAmount_${surface.id}`] = ref)}
                      {...inputConfig}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
          
          <div className={'row col-12 mx-0 px-0 mt-0'}>
            <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={theme.mocaOrange}>
              IP Detonator Type
            </Label>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
              IP Detonator Type
              </Label>
              <FormSelect
                placeholder={'Select detonator'}
                onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'detonatorType')}
                options={lookups.blastingReportDetonatorType || []}
                value={pit.explosiveUsage.detonatorType}
                disabled={isDisabled}
                valField={'name'}
                dispField={'name'}
                arrowSize={'16px'}
                ref={(ref) => (formRefs[`detonatorType_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Detonator Amount <span style={{color: theme.mocaOrange}}>(pcs)</span>
              </Label>
              <FormNumber
                placeholder={'0'}
                alignRight
                mb={'8px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'detonatorAmount')}
                value={pit.explosiveUsage.detonatorAmount}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`detonatorAmount_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
          </div>
        </CardContainer>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BLASTING_REPORT) {
    const blastingReport = state.lookups.data.BLASTING_REPORT
    const blastingReportExplosiveType = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'EXPLOSIVE_TYPE')
    const blastingReportDynamiteType = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'DYNAMITE_TYPE')
    const blastingReportInholeType = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'INHOLE_TYPE')
    const blastingReportInholeLength = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'INHOLE_LENGTH')
    const blastingReportSurfaceType = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'SURFACE_TYPE')
    const blastingReportSurfaceLength = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'SURFACE_LENGTH')
    const blastingReportDetonatorType = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'DETONATOR_TYPE')
    const blastingReportAmoniumNitrate = blastingReport.BLASTING_REPORT_EXPLOSIVE && blastingReport.BLASTING_REPORT_EXPLOSIVE.find((d) => d.name === 'AMONIUM_NITRATE_MULTIPLIER')
    lookups.blastingReportExplosiveType = blastingReportExplosiveType ? blastingReportExplosiveType.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportDynamiteType = blastingReportDynamiteType ? blastingReportDynamiteType.children.map((d) => ({ name: d.nameDisplay, children: d.children })) : []
    lookups.blastingReportInholeType = blastingReportInholeType ? blastingReportInholeType.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportInholeLength = blastingReportInholeLength ? blastingReportInholeLength.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportSurfaceType = blastingReportSurfaceType ? blastingReportSurfaceType.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportSurfaceLength = blastingReportSurfaceLength ? blastingReportSurfaceLength.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportDetonatorType = blastingReportDetonatorType ? blastingReportDetonatorType.children.map((d) => ({ name: d.nameDisplay })) : []
    lookups.blastingReportAmoniumNitrate = blastingReportAmoniumNitrate ? blastingReportAmoniumNitrate.nameDisplay : ""
  }
  return {
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExplosiveUsage)
)
